// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".medical-analyses-list[data-v-aca0e900] {\n  max-width: 1160px;\n}\n@media (max-width: 480px) {\n.documents-list__empty[data-v-aca0e900] {\n    padding: 0 20px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
